import { IChipOption } from 'components/ChipSelect';
import React from 'react';
import { LookupChipSelect } from '../LookupChipSelect';
import { JeTypeLookupWrapper } from './JeTypeLookupWrapper';

interface IProps {
  includeDeleted?: boolean;
  selectedIds?: number[];
  onChange: (selectedOptions: readonly IChipOption[]) => void;
  placeholder?: string;
}

export const JeTypeChipSelect = (props: IProps): JSX.Element => {
  return (
    <JeTypeLookupWrapper>
      {({ queryDocument, queryVariables, extractLookups }) => (
        <LookupChipSelect
          extractLookups={extractLookups}
          queryDocument={queryDocument}
          queryVariables={queryVariables}
          onChange={props.onChange}
          selectedIds={props.selectedIds}
          placeholder={props.placeholder}
        />
      )}
    </JeTypeLookupWrapper>
  );
};
